import React from 'react';
import './PhoneNumberInput.css';
import { RegistrationPhoneNumber } from '../../entities/RegistrationEntities';
import Select from '../../components/select/Select';

// ------------------------------------------------------------------------------------------------
// component

export interface PhoneNumberInputProps {
    name: string;
    value: RegistrationPhoneNumber;
    placeholder?: string;
    onChange: (name: string, value: RegistrationPhoneNumber) => void;
}

export const CountryCodesList = [
    { label: "NZ +64", id: "+64" },
    { label: "AU +61", id: "+61" }
]

export const PhoneNumberInput: React.FunctionComponent<PhoneNumberInputProps> = ({ ...props }) => {

    const { name, value, placeholder, onChange } = props

    // state
    const handleInput = (event: any) => {
        const inputValue = event.target.value.replace(/\D/g, '');
        let newValue = { ...value };
        newValue[event.target.name] = inputValue;
        onChange(name, newValue);
    }

    const handleSelect = (inputValue) => {
        if (inputValue === "") {
            return;
        }

        let newValue = { ...value };
        newValue.countryCode = inputValue
        onChange(name, newValue);
    }


    return (
        <div className='phone-number-container'>
            <div className="phone-number-input-select">
                <Select
                    name="countryCode"
                    value={value.countryCode}
                    onChange={(name, value) => { handleSelect(value) }}
                    options={CountryCodesList}
                />
            </div>

            <input
                type="text"
                className="phone-number-input-field"
                name="number"
                maxLength={20}
                placeholder={placeholder}
                onChange={handleInput}
                value={value.number}
            />
        </div>
    )
}